module.exports = __webpack_public_path__ + "img/VOLVO CARS.5280822f.jpg";